handleDotAll